(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yoface-policy"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('yoface-policy')) {
    customElements.define('yoface-policy', class extends HTMLElement {
      connectedCallback() {
        const toc = this.querySelector('[data-yfp-toc]');
        if (!toc) return;

        const desktop = window.matchMedia('(min-width: 990px)');
        const syncOpen = () => { toc.open = desktop.matches; };
        syncOpen();
        desktop.addEventListener('change', syncOpen);

        const links = new Map();
        this.querySelectorAll('[data-yfp-link]').forEach((a) => {
          links.set(a.dataset.yfpLink, a);
          a.addEventListener('click', () => { if (!desktop.matches) toc.open = false; });
        });

        const setActive = (id) => {
          links.forEach((a, key) => a.classList.toggle('is-active', key === id));
        };

        const topics = [...this.querySelectorAll('[data-yfp-topic]')];
        if (!topics.length || !('IntersectionObserver' in window)) return;

        const visible = new Set();
        this.observer = new IntersectionObserver((entries) => {
          entries.forEach((e) => (e.isIntersecting ? visible.add(e.target) : visible.delete(e.target)));
          const first = topics.find((t) => visible.has(t));
          if (first) setActive(first.id);
        }, { rootMargin: '-20% 0px -60% 0px' });
        topics.forEach((t) => this.observer.observe(t));
      }

      disconnectedCallback() {
        this.observer?.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
